import { Icon } from "./Icon.tsx";

/** "Control Rules" tab icon — an on/off toggle switch (what a rule actually
 * does: turn a pump/orifice/weir ON or OFF based on a condition), distinct
 * from OptionsIcon.tsx's own sliders and GearIcon.tsx's own gear. The
 * toggle handle is a small filled dot (matching PollutantIcon.tsx's own
 * dot radius) rather than the larger r=2 disc it used to be — the audit
 * flagged the bigger fill as visually louder than every other tab icon
 * in the Project Data menu, most of which are outline-only. */
export function ControlRuleIcon() {
  return (
    <Icon>
      <rect x="3" y="9" width="18" height="6" rx="3" />
      <circle cx="15" cy="12" r="1.3" fill="currentColor" stroke="none" />
    </Icon>
  );
}
